export default __webpack_public_path__ + "static/media/HomeHair1.7c9108e5.png";